<template>
  <!--顶部状态栏-->
  <div class="title-bar-v1" @click.stop @touchstart.stop>
    <!--返回上一页-->
    <template v-if="!isPocketMiniapp">
      <div class="icon icon-back" @click="$router.go(-1)" v-if="!noBack.includes($route.name)"></div>
    </template>
    <!--标题(自身标题权重大于传入的标题)-->

    <div class="local title" v-if="is58CityBar" >
      <div @click.stop="goCity" class="icon"></div>
      <span @click.stop="goCity">{{ currentCity.city_name ? currentCity.city_name : '深圳' }} </span>
    </div>
    <h1 v-else class="title">{{ title || data.title }}</h1>
    <!--菜单按钮-->
    <div class="icon icon-menu" v-if="data.menu && !isPocketMiniapp" :class="{ active: showMenu }"
      @click="showMenu = !showMenu">
      <ul class="bar-list">
        <li class="bar"></li>
        <li class="bar"></li>
        <li class="bar"></li>
        <li class="bar"></li>
        <li class="bar"></li>
      </ul>
      <!--下拉面板-->
      <ul class="drop-down" @click.stop>
        <li class="item" @click="toHome" v-if="GLOBAL_TITLEBAL_LINKTO[type].index">
          <i class="icon icon-home"></i>
          <span class="text">首页</span>
        </li>
        <li class="item" v-if="GLOBAL_TITLEBAL_LINKTO[type].usercenter" @click="toUserCenter">
          <i class="icon icon-user"></i>
          <span class="text">我的</span>
        </li>
        <li class="item" @click="toCollection" v-if="GLOBAL_TITLEBAL_LINKTO[type].collection && !from && !isPartner">
          <i class="icon icon-collection"></i>
          <span class="text">收藏</span>
        </li>
      </ul>
    </div>
    <div v-if="isCustomRight" class="icon icon-right">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import { noBack } from "@/config";
import { GLOBAL_TITLEBAL_LINKTO } from "@/assets/js/config";
import { comefromLink } from "@/assets/js/comefrom";
import wx from "weixin-js-sdk";
import { comefromConfigObj } from "@/assets/js/comefrom.js";
import { mapGetters } from "vuex";

export default {
  name: "TitleBarV1",
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    isCustomRight: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      noBack,
      isWechatSubscription,
      showMenu: false, // 是否显示菜单
      title: "",
      from: "",
      GLOBAL_TITLEBAL_LINKTO,
      type: "0", // 0代表袋鼠渠道，1代表好医生，2代表第三方公众号
      comefrom: sessionStorage.getItem("comefrom")
    };
  },
  methods: {
    init() {
      if (isWechatSubscription) {
        this.type = "2";
        return;
      }
    },
    goCity(){
      this.$router.push('/city-list?hideHotCity=1')
    },
    // 到个人中心
    toUserCenter() {
      if (this.getStoreComefrom) {
        comefromLink("usercenter");
        return;
      }

      this.showMenu = false;
      setTimeout(() => {
        // 判断是否从通用团检
        if (this.from === "comm_medical") {
          window.location.href =
            location.host.indexOf("test") !== -1
              ? `${location.protocol}\\\\${location.host
              }/tuanjian/public/common/#/person-center`
              : `${location.protocol}\\\\${location.host
              }/company/public/common/#/person-center`;
          return;
        }
        // 招行团检
        if (this.from === "cmb_medical") {
          window.location.href =
            location.host.indexOf("test") !== -1
              ? `http:\\\\${location.host}/tuanjian2/public/#/person-center`
              : `${location.protocol}\\\\${location.host
              }/company/public/#/person-center`;
          return;
        }
        this.$router.push({
          path: GLOBAL_TITLEBAL_LINKTO[this.type].usercenter
        });
      }, 50);
    },
    // 到首页
    toHome() {
      if (this.comefrom && this.getStoreComefrom) {
        comefromLink("home");
        return;
      }

      this.showMenu = false;
      // 判断是否从通用团检
      if (this.from === "comm_medical") {
        window.location.href =
          location.host.indexOf("test") !== -1
            ? `${location.protocol}\\\\${location.host
            }/tuanjian/public/common/#/`
            : `${location.protocol}\\\\${location.host
            }/company/public/common#/`;
        return;
      }
      // 招行团检
      if (this.from === "cmb_medical") {
        window.location.href =
          location.host.indexOf("test") !== -1
            ? `http:\\\\${location.host}/tuanjian2/public/#/`
            : `${location.protocol}\\\\${location.host}/company/public/#/`;
        return;
      }
      this.$router.push({
        path: GLOBAL_TITLEBAL_LINKTO[this.type].index
      });
    },
    // 到收藏页
    toCollection() {
      this.showMenu = false;
      setTimeout(() => {
        this.$router.push({
          path: GLOBAL_TITLEBAL_LINKTO[this.type].collection
        });
      }, 50);
    },
    setDefaultTitle() {
      this.title = this.$route.query.subTitle || "";
    }
  },
  created() {
    this.from = this.$route.query.from;
    this.setDefaultTitle();
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      let vm = this;
      $("body").on("click touchstart", function () {
        vm.showMenu = false;
      });
    });
  },
  watch: {
    $route() {
      this.setDefaultTitle();
    }
  },
  computed: {
    getStoreComefrom() {
      return this.$store.state.comefrom;
    },
    isPartner() {
      return this.$route.query.comefrom === "partner";
    },
    isPocketMiniapp() {
      return sessionStorage.getItem("comefrom") === "pocketInfirmarySystem";
    },
    is58CityBar() {
      return this.data.barCode && this.data.barCode === '58_city'
    },
    ...mapGetters(["currentCity"])
  }
};
</script>

<style lang="less" scoped>
@image: "../../assets/images/";


.title-bar-v1 {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1996;
  width: 100%;
  height: 82/200rem;
  line-height: 80/200rem;
  border-bottom: 1px solid #eee;
  background-color: #fff;

  .title {
    height: 100%;
    padding: 0 100/200rem;
    font-size: 30/200rem;
    color: #4e4e4e;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .local {
    display: flex;
    justify-content: center;
    align-items: center;
    .icon {
      position: relative;
      width: 30/200rem;
      height: 30/200rem;
      background: url("@{image}icon-local-1.png") no-repeat;
      background-size: 100%;
      background-position: 100%;
    }
    span {
      font-size: 26/200rem;
      max-width: 200/200rem;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }


  }

  .icon {
    position: absolute;
    top: 0;

    &.active {
      .drop-down {
        opacity: 1;
        pointer-events: auto;
        transform: translate3d(0, 0, 0);

        .item {

          .icon,
          .text {
            opacity: 1;
            transform: translate3d(0, 0, 0);
          }
        }
      }
    }

    &.icon-back {
      left: 0;
    }

    &.icon-menu {
      right: 0;
    }

    .drop-down {
      position: absolute;
      right: 8/200rem;
      top: 100%;
      width: 160/200rem;
      border-radius: 8/200rem;
      margin-top: 18/200rem;
      background-color: #414141;
      opacity: 0;
      pointer-events: none;
      transform: translate3d(0, -12/200rem, 0);
      transition: all 0.35s;

      &:before {
        content: "";
        position: absolute;
        left: 117/200rem;
        top: -12/200rem;
        width: 0;
        height: 0;
        border-width: 0 12/200rem 12/200rem;
        border-style: solid;
        border-color: transparent transparent #333;
      }

      .item {
        position: relative;
        height: 68/200rem;
        line-height: 68/200rem;
        font-size: 26/200rem;
        color: #b0b0b0;
        font-weight: 400;
        border-bottom: 1px solid #b0b0b0;

        &:last-child {
          border-bottom: none;
        }

        &:nth-child(1) {

          .icon,
          .text {
            transition: all 0.3s ease;
          }
        }

        &:nth-child(2) {

          .icon,
          .text {
            transition: all 0.4s ease;
          }
        }

        &:nth-child(3) {

          .icon,
          .text {
            transition: all 0.5s ease;
          }
        }

        .icon {
          position: absolute;
          left: 22/200rem;
          top: 50%;
          width: 28/200rem;
          height: 28/200rem;
          margin-top: -17/200rem;
          background-size: 100% 100%;
          opacity: 0;
          transform: translate3d(50/200rem, 0, 0);

          &.icon-user {
            background-image: url("@{image}icon-user-1.png");
          }

          &.icon-home {
            background-image: url("@{image}icon-home-3.png");
          }

          &.icon-collection {
            background-image: url("@{image}icon-collection-4.png");
          }
        }

        .text {
          position: absolute;
          left: 68/200rem;
          opacity: 0;
          transform: translate3d(50/200rem, 0, 0);
        }
      }
    }
  }

  .icon-back,
  .icon-menu {
    flex-shrink: 0;
    width: 80/200rem;
    height: 100%;
  }

  .icon-back {
    background: url("@{image}icon_back.png") no-repeat center center;
    background-size: 38% auto;
  }

  .icon-right {
    right: 44/200rem;
    font-size: 32/200rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fa9026;
  }

  .icon-menu {
    &.active .bar-list .bar {
      &:nth-child(1) {
        opacity: 0;
        transform: rotate(135deg);
      }

      &:nth-child(2) {
        opacity: 0;
        left: -30/200rem;
      }

      &:nth-child(3) {
        opacity: 0;
        transform: rotate(-135deg);
      }

      &:nth-child(4) {
        opacity: 1;
        transform: rotate(135deg);
      }

      &:nth-child(5) {
        opacity: 1;
        transform: rotate(-135deg);
      }
    }

    .bar-list {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 22/200rem;
      height: 18/200rem;
      margin: -9/200rem 0 0 -11/200rem;

      .bar {
        position: absolute;
        left: 0;
        width: 100%;
        height: 1px;
        opacity: 1;
        background-color: #4e4e4e;
        transform: rotate(0deg);
        transition: all 0.4s;

        &:nth-child(1) {
          top: 0;
        }

        &:nth-child(2),
        &:nth-child(4),
        &:nth-child(5) {
          top: 50%;
          margin-top: -0.5px;
        }

        &:nth-child(3) {
          bottom: 0;
        }

        &:nth-child(4) {
          opacity: 0;
          transform: rotate(0deg);
        }

        &:nth-child(5) {
          opacity: 0;
          transform: rotate(-0deg);
        }
      }
    }
  }
}
</style>
